import * as React from 'react'
import { useState } from 'react'
import { useQueryMaintenanceMode } from '@/modules/shared/query-client/useQueryMaintenanceMode'
import { useMutationMaintenanceMode } from '@/modules/shared/query-client/useMutationMaintenanceMode'

export const SystemTab: React.FC = () => {
  const { data, isLoading } = useQueryMaintenanceMode()
  const mutation = useMutationMaintenanceMode()
  const [message, setMessage] = useState('')

  React.useEffect(() => {
    if (data?.message) {
      setMessage(data.message)
    }
  }, [data?.message])

  if (isLoading) {
    return <div className="tw-p-6 tw-text-gray-500">Ładowanie...</div>
  }

  const isActive = data?.isActive ?? false

  const handleToggle = () => {
    mutation.mutate({ isActive: !isActive, message: isActive ? '' : message })
  }

  return (
    <div className="tw-p-6 tw-max-w-xl">
      <h3 className="tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-6">Przerwa techniczna</h3>

      <div className="tw-mb-4 tw-flex tw-items-center tw-gap-3">
        <span className="tw-text-sm tw-text-gray-600">Status:</span>
        <span
          className={`tw-text-sm tw-font-semibold ${isActive ? 'tw-text-orange-600' : 'tw-text-green-600'}`}
        >
          {isActive ? 'AKTYWNA' : 'NIEAKTYWNA'}
        </span>
      </div>

      {!isActive && (
        <div className="tw-mb-4">
          <label className="tw-block tw-text-sm tw-text-gray-600 tw-mb-1">
            Komunikat dla użytkowników (opcjonalny)
          </label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={3}
            placeholder="np. Trwa aktualizacja systemu. Wrócimy za kilka minut."
            className="tw-w-full tw-rounded tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm tw-resize-none focus:tw-outline-none focus:tw-border-blue-400"
          />
        </div>
      )}

      <button
        onClick={handleToggle}
        disabled={mutation.isPending}
        className={`tw-rounded tw-px-5 tw-py-2 tw-text-white tw-text-sm tw-font-semibold tw-cursor-pointer disabled:tw-opacity-50 ${
          isActive
            ? 'tw-bg-green-600 hover:tw-bg-green-700'
            : 'tw-bg-orange-500 hover:tw-bg-orange-600'
        }`}
      >
        {mutation.isPending
          ? 'Zapisywanie...'
          : isActive
          ? 'Wyłącz przerwę techniczną'
          : 'Włącz przerwę techniczną'}
      </button>
    </div>
  )
}
